var __cropper;
var restaurantModule = function () {
    var self = this;

    const RESIZE_MODAL = $('#resizeImageModal');
    const IMAGE_CROPPER = $('#resizeImageModal #imgCropper');
    const BTN_CROP = $('#resizeImageModal #btnCropImage');
    const BTN_ROTATE_LEFT = $('#resizeImageModal #image-rotate-left');
    const BTN_ROTATE_RIGHT = $('#resizeImageModal #image-rotate-right');
    const venueId = ($('#venueId').val() || '').trim();

    var FileUpload = null;
    var CloseModal = false;

    self.init = function () {
        var cropBoxData;
        var canvasData;
        RESIZE_MODAL.on('shown.bs.modal', function () {
            IMAGE_CROPPER.cropper({
                autoCropArea: 0.9,
                aspectRatio: 3/1,
                ready: function () {
                    __cropper = this.cropper;
                    IMAGE_CROPPER.cropper('setCanvasData', canvasData);
                    IMAGE_CROPPER.cropper('setCropBoxData', cropBoxData);
                },
                // viewMode: 2,
                cropend: function () {
                    // IMAGE_CROPPER.cropper('getCroppedCanvas').toDataURL("image/png");
                },
                cropmove: function(event) {
                    var data = this.cropper.getData();

                    if (data.width <= 50) {                        
                        data.width = 51;
                        this.cropper.setData(data);
                    }

                    if (data.height <= 50) {
                        data.height = 51;
                        this.cropper.setData(data);
                    }
                }
            });
        }).on('hidden.bs.modal', function () {
            IMAGE_CROPPER.cropper('reset');
            cropBoxData = IMAGE_CROPPER.cropper('getCropBoxData');
            canvasData = IMAGE_CROPPER.cropper('getCanvasData');
            IMAGE_CROPPER.cropper('destroy');
        })

        BTN_CROP.on('click', function (e) {
            resizeImage(IMAGE_CROPPER.cropper('getCroppedCanvas').toDataURL("image/png"), 1500, 500, function(canvas){
                const dataBlob = dataURItoBlob(canvas.toDataURL("image/png"));
                const file = new File([dataBlob], "image.png", {type:"image/png"});
                RESIZE_MODAL.modal('hide');
                if(FileUpload != null){
                  FileUpload.files = [];
                  FileUpload.files.push(file);
                  FileUpload.submit();
                }
               
            });
        })

        BTN_ROTATE_RIGHT.unbind('click');
        BTN_ROTATE_RIGHT.on('click', function(){
            __cropper.rotate(90);
        })

        BTN_ROTATE_LEFT.unbind('click');
        BTN_ROTATE_LEFT.on('click', function(){
            __cropper.rotate(-90);
        })

    }

   self.resizeImageShow = function (fileupload, close = false) {
        FileUpload = fileupload;
        CloseModal = close;
        const file = fileupload.files[0];
        const reader = new FileReader();
        reader.onload = function (e) {
            let canvas = document.createElement("canvas");
            let context = canvas.getContext('2d');
            let img = new Image();
            let base_img;
            img.src = reader.result;
            let scr_w = screen.width;
            let scr_h = screen.height;

            img.onload = function() {
                const ratio = img.height/img.width;
                if(check_iOSapp() || check_androidApp()) {
                    if(img.width < img.height){
                        canvas.width = 178;
                        canvas.height = canvas.width * ratio;
                    }else{
                       canvas.width = 268;
                       canvas.height = canvas.width * ratio;
                    }
                }else{
                    if(img.width < img.height){
                       canvas.width = 480;
                       canvas.height = canvas.width * ratio;
                    }else{
                       canvas.width = 720;
                       canvas.height = canvas.width * ratio;
                        
                    }
                }
                context.clearRect(0, 0, canvas.width, canvas.height);
                context.drawImage(img, 0, 0, canvas.width, canvas.height);
                base_img = canvas.toDataURL('image/jpeg');
                IMAGE_CROPPER.attr('src', base_img);
            }
            IMAGE_CROPPER[0].onload = function () {
                if (IMAGE_CROPPER[0].complete) {
                    RESIZE_MODAL.modal('show');
                }
            }

        }
        reader.readAsDataURL(file);
    };

    function dataURItoBlob(dataURI) {
        // convert base64/URLEncoded data component to raw binary data held in a string
        var byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0)
            byteString = atob(dataURI.split(',')[1]);
        else
            byteString = unescape(dataURI.split(',')[1]);
        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        // write the bytes of the string to a typed array
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ia], {
            type: mimeString
        });
    }

    function resizeImage(url, width, height, callback) {
        var sourceImage = new Image();

        sourceImage.onload = function() {
            // Create a canvas with the desired dimensions
            var canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;

            // Scale and draw the source image to the canvas
            canvas.getContext("2d").drawImage(sourceImage, 0, 0, width, height);

            // Convert the canvas to a data URL in PNG format
            callback(canvas);
        }
        sourceImage.src = url;
    }
}
